import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';
import { BottomMenuLink } from 'src/interfaces/news';

import { Typography } from '@sravni/react-design-system';

import styles from '../left-column.module.scss';

export const BottomMenuItem: React.FC<BottomMenuLink> = ({
  name,
  link,
  url,
  isActive,
  otherProps,
  isExternal,
  handleClick,
}) => {
  const propsHandleClick = handleClick ? { onClick: handleClick } : {};

  return (
    <Typography.Text
      size={12}
      key={name}
      className={classNames(styles.bottomLink, { [styles[`bottomLink--active`]]: isActive })}
    >
      {isExternal ? (
        <Typography.Link color={'dark'} href={url} {...otherProps} {...propsHandleClick}>
          {name}
        </Typography.Link>
      ) : (
        <Link href={link.href} as={link.as}>
          <Typography.Link color={'dark'} {...otherProps}>
            {name}
          </Typography.Link>
        </Link>
      )}
    </Typography.Text>
  );
};
